import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "custom-navi",
  style: {"padding-bottom":"70px"}
}

import { defineComponent, reactive, toRefs, watch, ref, onMounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import {  
  UserStatusMap,
  UserRoleOperator,
  UserRoleDirectorManager,
  UserRoleDirector,
  UserRoleBlogger,
  UserRoleAuditor,
} from '@/utils/macro'

import NavDatas from './navs'




export default /*@__PURE__*/_defineComponent({
  __name: 'Navi',
  setup(__props) {

const isProd = ref(window.location.hostname=='marsadmin.marsvis.com')

const store = useStore()

const user_role = computed(() => store.state.user.role)

const router = useRouter()
const route = useRoute()

console.log('route.meta.key', route.meta.key);

const openKeys = ref([])
const selectedKeys = ref([])

// onMounted(() => {
//   selectedKeys.value = [route.path]
//   console.log('route', route);
  
//   openKeys.value = [route.meta.key]
//   console.log('openKeys.value', route.meta.key);
// })

// 监听路由变化
watch(() => route.path, (newRoute) => {
  selectedKeys.value = [newRoute]
  openKeys.value = [route.meta.key]
}, { immediate: true })


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_menu, {
      openKeys: openKeys.value,
      "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((openKeys).value = $event)),
      selectedKeys: selectedKeys.value,
      "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
      mode: "inline"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(NavDatas), (items) => {
          return (_openBlock(), _createBlock(_component_a_sub_menu, {
            key: items.key
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(items.title), 1)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.children, (child) => {
                return (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: child.key
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: { path: child.key}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(child.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["openKeys", "selectedKeys"])
  ]))
}
}

})